export default __webpack_public_path__ + "static/media/new_kingdom_1_1x.1f990a17.webp";